import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';
import Tag from 'antd/lib/tag';
import ListItem from '../shared/ListItem';
import { selectSelectedReport } from '../../redux/store/userData/reports';
import { regenerateReport } from '../../redux/store/userData/reports/thunk';
import { renderText } from '../shared/DrawerLayout/renderText';
import { colors } from '../../theme/theme';
import styles from './ReportInfo.styles';
import { openConfirmModal } from '../../redux/store/ui/common';

const ReportInfo: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedReport = useSelector(selectSelectedReport) as any;
  const status = selectedReport?.status;

  const formatDate = (date?: string) =>
    date ? moment(date).format('DD MMM. YYYY') : '-';

  const onClickRegenerate = () => {
    dispatch(
      openConfirmModal({
        destructive: true,
        title: intl.formatMessage({
          id: `fleetadmin.report.regenerate.msg`,
        }),
        onConfirm: () => {
          dispatch(regenerateReport(selectedReport.id));
        },
      })
    );
  };

  return (
    <>
      <div className="report-info">
        <ListItem
          testid="reportClass"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.reportclass',
          })}
          value={renderText(selectedReport?.reportClass)}
        />
        <ListItem
          testid="from"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.from',
          })}
          value={renderText(formatDate(selectedReport?.from))}
        />
        <ListItem
          testid="to"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.to',
          })}
          value={renderText(formatDate(selectedReport?.to))}
        />
        <ListItem
          testid="fileName"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.filename',
          })}
          value={renderText(selectedReport?.fileName)}
        />
        <ListItem
          testid="status"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.status',
          })}
          value={renderText(
            intl.formatMessage({
              id: `fleetadmin.reports.table.${status}`,
            })
          )}
        />
        <ListItem
          testid="type"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.type',
          })}
          value={
            selectedReport?.type ? (
              <Tag color="default">{selectedReport.type}</Tag>
            ) : (
              <span>-</span>
            )
          }
        />
        <ListItem
          testid="uploadUrl"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.uploadurl',
          })}
          value={
            selectedReport?.url ? (
              <span
                style={{ color: colors.blue, cursor: 'pointer' }}
                onClick={() => window.open(selectedReport.url, '_blank')}
              >
                open
              </span>
            ) : (
              <span>-</span>
            )
          }
        />
        <ListItem
          testid="statusCode"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.statuscode',
          })}
          value={
            selectedReport?.statusCode != null ? (
              <span>{selectedReport.statusCode}</span>
            ) : (
              <span>-</span>
            )
          }
        />
        <ListItem
          testid="created"
          label={intl.formatMessage({
            id: 'fleetadmin.reports.drawer.created',
          })}
          value={renderText(formatDate(selectedReport?.created))}
        />
        {selectedReport?.pendingSince && (
          <ListItem
            testid="pendingSince"
            label={intl.formatMessage({
              id: 'fleetadmin.reports.drawer.pendingsince',
            })}
            value={renderText(formatDate(selectedReport.pendingSince))}
          />
        )}
        {selectedReport?.processingAt && (
          <ListItem
            testid="processingAt"
            label={intl.formatMessage({
              id: 'fleetadmin.reports.drawer.processingat',
            })}
            value={renderText(formatDate(selectedReport.processingAt))}
          />
        )}
        {selectedReport?.generatedAt && (
          <ListItem
            testid="generatedAt"
            label={intl.formatMessage({
              id: 'fleetadmin.reports.drawer.generatedat',
            })}
            value={renderText(formatDate(selectedReport.generatedAt))}
          />
        )}
        {selectedReport?.uploadedAt && (
          <ListItem
            testid="uploadedAt"
            label={intl.formatMessage({
              id: 'fleetadmin.reports.drawer.uploadedat',
            })}
            value={renderText(formatDate(selectedReport.uploadedAt))}
          />
        )}
        {selectedReport?.locale && (
          <ListItem
            testid="locale"
            label={intl.formatMessage({
              id: 'fleetadmin.reports.drawer.locale',
            })}
            value={renderText(selectedReport.locale)}
          />
        )}
        <span className="red-action" onClick={onClickRegenerate}>
          {intl.formatMessage({
            id: 'fleetadmin.reports.drawer.regenerate',
          })}
        </span>
        {selectedReport?.s3URL && (
          <a
            className="blue-action"
            href={selectedReport.s3URL}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            {intl.formatMessage({
              id: 'fleetadmin.reports.drawer.download',
            })}
          </a>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ReportInfo;
